import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=4aee32ec&"
import script from "./Diversity.vue?vue&type=script&lang=js&"
export * from "./Diversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports